import * as React from "react";
import { forwardRef } from "react";
const SvgTextItalic = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 3H8.28571M11.7143 17H4M12.5714 3L7.42857 17", stroke: "#2C2D32", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTextItalic);
export default ForwardRef;
